module.exports = __webpack_public_path__ + "static/14-814a2fa67c188dfa0840ccb65989f865.jpg";